import { Query } from "@tanstack/react-query";
import { DocumentsModel } from "types/generated/models";
import { useGetQuery } from "hooks/useClientPortalQuery";
import { useClientPortalConfigContext } from "../../../context";

export const enum DocumentType {
    Shared = "Shared",
    Uploads = "Uploads",
}

function buildDocumentsEndpointUrl(clientPortalGuid: string, type: DocumentType) {
    return `/api/v1/${clientPortalGuid}/Documents/${type}`;
}

export function isDocumentsQuery(query: Query, clientPortalGuid: string) {
    return (
        query.queryKey[0] === buildDocumentsEndpointUrl(clientPortalGuid, DocumentType.Uploads) ||
        query.queryKey[0] === buildDocumentsEndpointUrl(clientPortalGuid, DocumentType.Shared)
    );
}

export function useDocuments(type: DocumentType) {
    const { clientPortalGuid } = useClientPortalConfigContext();
    const { data, isLoading } = useGetQuery<DocumentsModel>({
        url: buildDocumentsEndpointUrl(clientPortalGuid, type),
    });

    return {
        documents: data?.documents ?? [],
        isLoading,
    };
}
